import {
  Component,
  OnInit,
  TemplateRef,
  Input,
  ViewChild,
  EventEmitter,
  Output,
  ChangeDetectorRef,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PropertyListingService } from '../../shared/providers/property-listing.service';
import { IPropertySearchCriteria } from '../../shared/models/propertysearchcriteria';
import { IPropertyCard } from '../../shared/models/propertycard';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { PropertyListingBase } from '../property-listing-base';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { IFilterable } from '../filterable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { LoaderService } from '../../shared/providers/loader.service';
import { PropertyFor } from '../../shared/enum/enum';
import { IAddToFavorites } from '../../shared/models/AddToFavoriteInputModel';
import { AddTo1031Exchange } from '../../shared/models/AddTo1031ExchangeModel';
import { PropertyManagementService } from '../../shared/providers/property-management.service';
import { ToastService } from '../../shared/providers/toast.service';
import { IExchangeCodeOutputModel } from '../../shared/models/ExchangeCodeOutputModel';
import { ValidationService } from '../../shared/providers/validation.service';
import { CommonService } from '../../shared/providers/common.service';
import { ILookUp } from '../../shared/models/LookUpOutputModel';
import { OnChanges } from '@angular/core';
import { collapseColumns } from '../../shared/models/collapseColumns';
import { Subject } from 'rxjs';
import { IPropertyChatModel } from '../../shared/models/PropertyChatModel';
import { SharedService } from '../../shared/providers/shared.service';
import { UserManagerService } from '../../shared/providers/user-manager.service';
import { Trade1031Service } from 'src/app/shared/providers/Trade1031.service';

@Component({
  selector: 'property-list-view',
  templateUrl: './property-list-view.component.html',
})
export class PropertyListViewComponent
  extends PropertyListingBase
  implements IFilterable, OnInit, OnChanges {
  propertiesEx: IPropertyCard[] = [];
  selectedRows: IPropertyCard[] = [];
  propertyFor = PropertyFor;
  isPropertyForSale = true;
  test: number;
  classToBind = 'fav';
  classToBind1031 = 'label1031';
  classToBindDislike = 'dislike';
  modalRef: BsModalRef;
  @Input() searchCriteria: IPropertySearchCriteria;
  @ViewChild(DataTableDirective, { static: true })
  dtElement: DataTableDirective;
  addToFavorites = {} as IAddToFavorites;
  addTo1031Exchange = {} as AddTo1031Exchange;
  dtOptions = {};
  @Input() property: IPropertyCard;
  exchangeCodes: IExchangeCodeOutputModel[];
  groupList: ILookUp[];
  sharedOmProperties: number[] = [];
  propertyChatModel = {} as IPropertyChatModel;
  @Input() propertiesExIsFav: IPropertyCard[];
  @Input() propertiesExIs1031: IPropertyCard[];
  @Input() propertiesExIsDisliked: IPropertyCard[];
  showDisLike: boolean = false;
  showAddToExchange: boolean = false;
  showAddToFav: boolean = false;
  selectedPropertyGuid = '';
  Datacolumns = [];
  actionHeadDisable: boolean = false;
  enableMessage: boolean = false;
  capratetext: string;
  //defaultTypeText: IMultiSelectTexts = {
  //  //checked: 'column selected',
  //  //checkedPlural: 'columns selected',
  //  defaultTitle: 'Select Columns',
  //};
  defaultTypeSettings = {
    singleSelection: false,
    text: "Select Columns",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 1
  };
  selectedColumns = [];
  @Output() propertyListCount: EventEmitter<any> = new EventEmitter<any>();
  tableColumns: collapseColumns[] = [];
  dtTrigger = new Subject();
  public getPropertyCount(propertyListCount: any): void {
    this.propertyListCount.emit(propertyListCount);
  }

  constructor(
    private router: Router,
    protected http: HttpClient,
    protected _propertyListingService: PropertyListingService,
    public authService: AuthenticationService,
    protected loaderService: LoaderService,
    private _propertyManagerService: PropertyManagementService,
    private _toastService: ToastService,
    private trade1031Service: Trade1031Service,
    public _ValidationService: ValidationService,
    private _userService: UserManagerService,
    public _commonService: CommonService,
    private Shared: SharedService,
    private modalService: BsModalService,
    protected activatedRoute: ActivatedRoute,
    private cdRef: ChangeDetectorRef
  ) {
    super(
      _propertyListingService,
      http,
      authService,
      loaderService,
      activatedRoute
    );
    this.showAddToExchange = false;
  }

  propertyForChanged = false;
  filter(searchParameters: IPropertySearchCriteria) {
    this.onRedirection();
    if (
      this._propertyListingService.criteria.PropertyFor !==
      parseInt(localStorage.getItem('buypage_selectedRows_currentTab'))
    ) {
      this.resetSelectedRows();
      this.propertyForChanged = true;
    }
    this.searchCriteria = searchParameters;
    if (
      this.searchCriteria.StateId != null &&
      this.searchCriteria.StateId != undefined &&
      typeof this.searchCriteria.StateId === 'number'
    ) {
      this.searchCriteria.StateId = this.searchCriteria.StateId;
    }
    //} else if ((this.searchCriteria.StateId != null && this.searchCriteria.StateId != undefined) && typeof this.searchCriteria.StateId === 'object') {
    //  this.searchCriteria.StateId = this.searchCriteria.StateId[0] ?? null;
    //}
    //this.user = this.authService.user;
    this.searchCriteria.LoggedInUserId = this.user != null ? this.user.Id : 0;
    this.isPropertyForSale = searchParameters.PropertyFor === 601;
    this.test = searchParameters.PropertyFor;
    this.BindColumns();
    //this.allowOnchange = false;

    console.log('Filtered');

    //if (this.dtElement && this.dtElement.dtInstance) {
    //  this.dtElement.dtInstance.then((dtInstance) => {
    //    dtInstance.destroy();  // Destroy the current DataTable instance
    //    this.dtTrigger.next(true);  // Trigger the re-initialization
    //  });
    //}
    this.dtElement.dtInstance.then(x => x.draw());
  }

  viewDetail(guid: any) {
    this.router.navigate(['/viewproperty/' + guid]);
  }
  selectedIndex = -1;
  selecteRow(rowIndex) {
    this.selectedIndex = rowIndex;
  }
  showProcessing = true;
  isFav = false;
  isDisliked = false;
  ngOnInit() {
    this.loadContent();
  }
  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
    this.dtTrigger.next(true);
  }

  IsLoading = false;

  loadContent() {
    this.showAddToExchange = false;
    this.BindColumns();
    this.showDisLike = this._propertyListingService.showDisLike;
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.isFav = params['isFav'] != undefined ? true : false;
      this.search = params['search'];
      if (!this._ValidationService.IsinValid(this.search)) {
        this.searchCriteria = this._propertyListingService.criteria;
      }

      if (
        this._propertyListingService.showDisLike == undefined ||
        this._propertyListingService.showDisLike == false
      ) {
        this.showDisLike = params['isDisliked'] != undefined ? true : this.searchCriteria.IsDisliked ? true : false;
      }
      if (this._propertyListingService.criteria != undefined) {
        this.isPropertyForSale =
          this._propertyListingService.criteria.PropertyFor != undefined &&
            this._propertyListingService.criteria.PropertyFor == 602
            ? false
            : true;
      } else {
        this.isPropertyForSale =
          this._propertyListingService.activePropertyTab != undefined &&
            this._propertyListingService.activePropertyTab == 602
            ? false
            : true;
      }
      this.isFav = this.isFav ? this.isFav : this.searchCriteria.IsFavorite ? true : false;
      this.user = this.authService.user;
      this.searchCriteria.LoggedInUserId = this.user != null ? this.user.Id : 0;
      this.searchCriteria.IsFavorite = this.isFav;
      const that = this;
      this.addDataColumn();
      var defaultColumnOrder = [
        [this.Datacolumns.findIndex((x) => x.data == 'Price'), 'desc'],
      ]; // price
      if (this.searchCriteria.AddressType == 1) {
        //defaultColumnOrder = [[this.Datacolumns.findIndex(x => x.data == "Rank"), "desc"]];
        defaultColumnOrder = [
          [this.Datacolumns.findIndex((x) => x.data == 'Price'), 'desc'],
        ];
      }
      if (this.isFav) {
        this.dtOptions = {
          pagingType: 'full_numbers',
          serverSide: true,
          processing: this.showProcessing,
          info: false,
          pageLength: 50,
          language: {
            zeroRecords: null,
            processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
          },
          stateSave: true,
          stateSaveCallback: function (settings, data) {
            localStorage.setItem(
              'DataTables_property_list_view_Fav',
              JSON.stringify(data)
            );
          },
          stateLoadCallback: function (settings) {
            return that.getDataTablestate('DataTables_property_list_view_Fav');
          },
          order: defaultColumnOrder,
          bLengthChange: false,
          initComplete: () => $('.dataTables_filter').css('display', 'none'),
          ajax: (dataTablesParameters: any, callback: Function) => {
            this.IsLoading = true;
            this.selectedIndex = -1;
            dataTablesParameters.Extra_param = this.searchCriteria;
            that.http
              .post<DataTablesResponse>(
                this.BASE_URL + '/property/propertieslistview',
                dataTablesParameters,
                {}
              )
              .subscribe((resp) => {
                that.propertiesEx = resp ? (resp.data ? resp.data : []) : [];
                that.propertiesEx.forEach((item) => {
                  item.Remaining_Term =
                    this._ValidationService.remainingTermForCardandTables(
                      item.LeaseExpiration,
                      item.LeaseCommencementDate
                    );
                  if (item.CharacteristicsId) {
                    item.capRateText = 'ZCF';
                  } else {
                    item.capRateText = item.CapRate;
                  }
                });
                this.isPropertyForSale =
                  this.searchCriteria.PropertyFor === 601;
                this.propertiesExIsFav = that.propertiesEx.filter(
                  (x) => x.IsFav === 1
                );
                if (this.showDisLike) {
                  this.propertiesExIsDisliked = that.propertiesEx.filter(
                    (x) => x.IsDisliked === 1
                  );
                  this.propertiesExIsDisliked.forEach((item) => {
                    this.classToBindDislike = 'favlinkintableactive';
                  });
                }
                if (this.searchCriteria.IsFavorite) {
                  that.propertiesEx = that.propertiesEx.filter(
                    (x) => x.IsFav === 1
                  );
                }
                if (resp.data.length === 0) {
                  $('.dataTables_paginate.paging_full_numbers').hide();
                } else {
                  $('.dataTables_paginate.paging_full_numbers').show();
                }
                if (resp) {
                  callback({
                    recordsTotal: resp.recordsTotal,
                    recordsFiltered: resp.recordsFiltered,
                    data: [],
                  });
                } else {
                  callback({
                    recordsTotal: 0,
                    recordsFiltered: 0,
                    data: [],
                  });
                }
                that.showAllPortfolioProperties(
                  that.propertiesEx
                    .filter((x) => x.IsPortfolio)
                    .map((x) => x.Id)
                );
                $('.paginate_button.first,.paginate_button.last').hide();
                this.IsLoading = false;
                ////that.dtElement.dtOptions.stateLoadCallback(() => {
                ////    $(".dataTables_paginate.paging_full_numbers").show();
                ////    return JSON.parse(localStorage.getItem("DataTables_property_list_view_Fav"))
                ////});
              });
          },
          columnDefs: [
            { orderable: false, targets: 0 },
            { orderable: false, targets: 1 },
          ],
          columns: that.Datacolumns,
        };
      } else if (this.isDisliked) {
        this.dtOptions = {
          pagingType: 'full_numbers',
          serverSide: true,
          processing: this.showProcessing,
          info: false,
          pageLength: 50,
          language: {
            zeroRecords: null,
            processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
          },
          stateSave: true,
          stateSaveCallback: function (settings, data) {
            localStorage.setItem(
              'DataTables_property_list_view_Disliked',
              JSON.stringify(data)
            );
          },
          stateLoadCallback: function (settings) {
            return that.getDataTablestate(
              'DataTables_property_list_view_Disliked'
            );
          },
          order: defaultColumnOrder,
          bLengthChange: false,
          initComplete: () => $('.dataTables_filter').css('display', 'none'),
          ajax: (dataTablesParameters: any, callback: Function) => {
            this.selectedIndex = -1;
            this.IsLoading = true;
            dataTablesParameters.Extra_param = this.searchCriteria;
            that.http
              .post<DataTablesResponse>(
                this.BASE_URL + '/property/propertieslistview',
                dataTablesParameters,
                {}
              )
              .subscribe((resp) => {
                that.propertiesEx = resp ? (resp.data ? resp.data : []) : [];
                that.propertiesEx.forEach((item) => {
                  item.Remaining_Term =
                    this._ValidationService.remainingTermForCardandTables(
                      item.LeaseExpiration,
                      item.LeaseCommencementDate
                    );
                  if (item.CharacteristicsId) {
                    item.capRateText = 'ZCF';
                  } else {
                    item.capRateText = item.CapRate;
                  }
                });
                this.isPropertyForSale =
                  this.searchCriteria.PropertyFor === 601;
                this.propertiesExIsFav = that.propertiesEx.filter(
                  (x) => x.IsFav === 1
                );
                if (this.showDisLike) {
                  this.propertiesExIsDisliked = that.propertiesEx.filter(
                    (x) => x.IsDisliked === 1
                  );
                  this.propertiesExIsDisliked.forEach((item) => {
                    this.classToBindDislike = 'favlinkintableactive';
                  });
                }
                if (this.searchCriteria.IsFavorite) {
                  that.propertiesEx = that.propertiesEx.filter(
                    (x) => x.IsFav === 1
                  );
                }
                if (resp.data.length === 0) {
                  $('.dataTables_paginate.paging_full_numbers').hide();
                } else {
                  $('.dataTables_paginate.paging_full_numbers').show();
                }
                if (resp) {
                  callback({
                    recordsTotal: resp.recordsTotal,
                    recordsFiltered: resp.recordsFiltered,
                    data: [],
                  });
                } else {
                  callback({
                    recordsTotal: 0,
                    recordsFiltered: 0,
                    data: [],
                  });
                }
                that.showAllPortfolioProperties(
                  that.propertiesEx
                    .filter((x) => x.IsPortfolio)
                    .map((x) => x.Id)
                );
                $('.paginate_button.first,.paginate_button.last').hide();
                this.IsLoading = false;
              });
          },
          columnDefs: [
            { orderable: false, targets: 0 },
            { orderable: false, targets: 1 },
          ],
          columns: that.Datacolumns,
        };
      } else {
        this.reassignSelectedRows();
        this.dtOptions = {
          pagingType: 'full_numbers',
          serverSide: true,
          processing: this.showProcessing,
          pageLength: 50,
          info: false,
          language: {
            zeroRecords: null,
            processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
          },
          stateSave: true,
          stateSaveCallback: function (settings, data) {
            localStorage.setItem(
              'DataTables_property_list_view',
              JSON.stringify(data)
            );
          },
          stateLoadCallback: function (settings) {
            //var data = JSON.parse(localStorage.getItem("DataTables_property_list_view"));
            //if (that.searchCriteria.AddressType == 1) {
            //    data.order = [[17, "desc"]];
            //}
            //$(".dataTables_paginate.paging_full_numbers").show();
            return that.getDataTablestate('DataTables_property_list_view');
          },
          order: defaultColumnOrder,
          bLengthChange: false,
          initComplete: () => $('.dataTables_filter').css('display', 'none'),
          ajax: (dataTablesParameters: any, callback: Function) => {
            this.IsLoading = true;
            this.selectedIndex = -1;
            dataTablesParameters.Extra_param = this.searchCriteria;
            console.log(this.searchCriteria);
            that.http
              .post<DataTablesResponse>(
                this.BASE_URL + '/property/propertieslistview',
                dataTablesParameters,
                {}
              )
              .subscribe((resp) => {
                that.propertiesEx = resp ? (resp.data ? resp.data : []) : [];
                //this.BindColumns();
                this.getPropertyCount(resp.recordsTotal);
                that.propertiesEx.forEach((item) => {
                  item.Remaining_Term =
                    this._ValidationService.remainingTermForCardandTables(
                      item.LeaseExpiration,
                      item.LeaseCommencementDate
                    );
                  if (item.CharacteristicsId) {
                    item.capRateText = 'ZCF';
                  } else {
                    item.capRateText = item.CapRate;
                  }
                  if (
                    this.selectedRows.findIndex((x) => x.Id == item.Id) > -1
                  ) {
                    item.IsSelected = true;
                  }
                });
                //this.allowOnchange = true;
                this.isPropertyForSale =
                  this.searchCriteria.PropertyFor === 601;
                this.autoSelectAll();

                this.propertiesExIsFav = that.propertiesEx.filter(
                  (x) => x.IsFav === 1
                );
                if (this.showDisLike) {
                  this.propertiesExIsDisliked = that.propertiesEx.filter(
                    (x) => x.IsDisliked === 1
                  );
                  this.propertiesExIsDisliked.forEach((item) => {
                    this.classToBindDislike = 'favlinkintableactive';
                  });
                }
                if (this.searchCriteria.IsFavorite) {
                  that.propertiesEx = that.propertiesEx.filter(
                    (x) => x.IsFav === 1
                  );
                }
                if (resp.data.length === 0) {
                  $('.dataTables_paginate.paging_full_numbers').hide();
                } else {
                  $('.dataTables_paginate.paging_full_numbers').show();
                }
                if (resp) {
                  callback({
                    recordsTotal: resp.recordsTotal,
                    recordsFiltered: resp.recordsFiltered,
                    data: [],
                  });
                } else {
                  callback({
                    recordsTotal: 0,
                    recordsFiltered: 0,
                    data: [],
                  });
                }
                that.showAllPortfolioProperties(
                  that.propertiesEx
                    .filter((x) => x.IsPortfolio)
                    .map((x) => x.Id)
                );

                $('.paginate_button.first,.paginate_button.last').hide();
                this.IsLoading = false;
              });
          },
          columns: that.Datacolumns,
        };
      }

      this.setUserActions();
    });
  }
  autoSelectAll() {
    if (
      this.propertiesEx.filter((x) => x.IsSelected == true).length ==
      this.propertiesEx.length &&
      this.propertiesEx.length > 0
    ) {
      this.selectAll = true;
    } else {
      this.selectAll = false;
    }
  }
  setUserActions() {
    this.authService.isLoggedIn.subscribe((response) => {
      this.isUserLoggedIn = response;
      this.user = this.authService.user;
      if (this.user !== null) {
        if (
          this.authService.IsUserRole(this.authService.UserRole.Broker) &&
          this.isPropertyForSale == false
        ) {
          this.showAddToExchange = false;
          if (this.dtElement.dtInstance != undefined) {
            this.dtElement.dtInstance.then((x) => x.draw(false));
          }
        } else {
          this.showAddToExchange = false;
        }
        if (
          this.authService.IsUserRole(
            this.authService.UserRole.Principal1031
          ) ||
          this.authService.IsUserRole(this.authService.UserRole.Principal) ||
          this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)
        ) {
          this.showAddToFav = true;
          if (this.dtElement.dtInstance != undefined) {
            this.dtElement.dtInstance.then((x) => x.draw(false));
          }
        }
        if (
          document.getElementsByClassName('actionHeader')[0] != null &&
          document.getElementsByClassName('actionHeader')[0] != undefined
        ) {
          document
            .getElementsByClassName('actionHeader')[0]
            .classList.remove('sorting_asc');
          document
            .getElementsByClassName('actionHeader')[0]
            .className.replace('sorting_asc', '');
        }
        if (this.authService.IsUserRole(this.authService.UserRole.Broker)) {
          this.actionHeadDisable = false;
        } else if (
          this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)
        ) {
          this.actionHeadDisable = false;
        } else if (
          (this.authService.IsUserRole(
            this.authService.UserRole.Principal1031
          ) ||
            this.authService.IsUserRole(this.authService.UserRole.Principal)) &&
          this.isPropertyForSale == true
        ) {
          this.actionHeadDisable = true;
        } else if (
          this.authService.IsUserRole(this.authService.UserRole.DataEntryStaff)
        ) {
          this.actionHeadDisable = false;
        } else {
          this.actionHeadDisable = true;
        }
        if (
          this.authService.IsUserRole(
            this.authService.UserRole.Principal1031
          ) ||
          this.authService.IsUserRole(this.authService.UserRole.Broker) ||
          this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) ||
          this.authService.IsUserRole(this.authService.UserRole.Admin)
        ) {
          this.enableMessage = true;
        }
      }
    });
  }

  ngOnChanges() {
    this.showDisLike = this._propertyListingService.showDisLike;
    if (this._propertyListingService.criteria != undefined) {
      this.isPropertyForSale =
        this._propertyListingService.criteria.PropertyFor != undefined &&
          this._propertyListingService.criteria.PropertyFor == 602
          ? false
          : true;
    } else {
      this.isPropertyForSale =
        this._propertyListingService.activePropertyTab != undefined &&
          this._propertyListingService.activePropertyTab == 602
          ? false
          : true;
    }
    this.addDataColumn();
    this.setUserActions();
  }

  search = '';
  onViewProperty(Guid) {
    this.onRedirection();
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.search = params['search'];
      this.isFav = params['isFav'] != undefined ? true : false;
      this.isDisliked = params['isDisliked'] != undefined ? true : false;
    });
    if (this.isFav) {
      this.router.navigateByUrl(
        'viewproperty/' +
        Guid +
        '?prevroute=Favorites&link=' +
        encodeURIComponent(this.router.url)
      );
    } else if (this.isDisliked) {
      this.router.navigateByUrl(
        'viewproperty/' +
        Guid +
        '?prevroute=Disliked&link=' +
        encodeURIComponent(this.router.url)
      );
    } else if (!this._ValidationService.IsinValid(this.search)) {
      this.router.navigateByUrl(
        'viewproperty/' +
        Guid +
        '?prevroute=Saved Search&link=' +
        encodeURIComponent(this.router.url)
      );
    } else {
      this.router.navigateByUrl(
        'viewproperty/' +
        Guid +
        '?prevroute=Property List&link=' +
        encodeURIComponent(this.router.url)
      );
    }
  }

  @ViewChild('addToExchange') addToExchange: TemplateRef<any>;
  modalRefAddToExchange: BsModalRef;
  selectedPid = 0;
  addToFav(propertyId: any) {
    let property = this.propertiesEx.find((x) => x.Id == propertyId);

    this.authService.isLoggedIn.subscribe((i) => {
      this.isUserLoggedIn = i;
    });
    this.user = this.authService.user;
    if (this.isUserLoggedIn) {
      if (
        this.authService.IsUserRole(this.authService.UserRole.Principal) ||
        this.authService.IsUserRole(this.authService.UserRole.Principal1031) ||
        this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)
      ) {
        this.addToFavorites.UserId = this.user.Id;
        this.addToFavorites.PropertyId = propertyId;
        if (property.IsFav == 0) {
          if (property.PropertyForId == 602) {
            this.trade1031Service
              .GetExchangeCode(this.user.Id)
              .subscribe((res) => {
                this.exchangeCodes = res;
                if (this.exchangeCodes.length > 1) {
                  this.selectedPid = property.Id;
                  this.modalRefAddToExchange = this.modalService.show(
                    this.addToExchange,
                    {
                      class: 'panlestyle',
                    }
                  );
                } else {
                  this.saveAddToFav(property);
                }
              });
          } else {
            property.IsFav = 1;
            this.saveAddToFav(property);
          }
        } else {
          this.saveAddToFav(property);
        }
      } else {
        property.IsFav = 0;
        this._toastService.addToast({
          title: 'Unauthorized Action',
          msg: 'Please Login as a principal to add to your favorites.',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error',
        });
        this.dtElement.dtInstance.then((x) => x.draw(false));
      }
    } else {
      property.IsFav = 0;
      this._toastService.addToast({
        title: 'Unauthorized Action',
        msg: 'Please Login to add to your favorites.',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
      this.dtElement.dtInstance.then((x) => x.draw(false));
    }
  }

  private saveAddToFav(property: IPropertyCard) {
    this._propertyManagerService
      .addToFavorite(this.addToFavorites)
      .subscribe((response) => {
        this.showProcessing = false;
        if (response == '1') {
          property.IsFav = 1;
          this.classToBind = 'favlinkintableactive';
          this.dtElement.dtInstance.then((x) => x.draw(false));
          this._toastService.addToast({
            title: 'Message',
            msg: 'This property has been added to your favorites.',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'success',
          });
        } else {
          property.IsFav = 0;
          this.classToBind = 'favlinkintable';
          this.dtElement.dtInstance.then((x) => x.draw(false));
          this._toastService.addToast({
            title: 'Message',
            msg: 'This property has been removed from your favorites.',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'success',
          });
        }
        if (this.isFav) {
          this.decrementPropertyCount.emit(1);
        }
      });
  }

  addToExchangeSave(exchangeId: number[]) {
    this.addToFavorites.ExchangeId = exchangeId;
    let property = this.propertiesEx.find((x) => x.Id == this.selectedPid);
    property.IsFav = 1;
    this.saveAddToFav(property);
    this.modalRefAddToExchange.hide();
  }

  savePropertyto1031Exchange() {
    if (this.exchangeCodes.length > 0) {
      if (
        this.addTo1031Exchange.Exchange1031Id != null &&
        this.addTo1031Exchange.Exchange1031Id != undefined &&
        this.addTo1031Exchange.Exchange1031Id != 0
      ) {
        if (
          this.addTo1031Exchange.Exchange1031GroupId != null &&
          this.addTo1031Exchange.Exchange1031GroupId != undefined &&
          this.addTo1031Exchange.Exchange1031GroupId != 0
        ) {
          this._propertyManagerService
            .addTo1031Exchange(this.addTo1031Exchange)
            .subscribe((response) => {
              if (response) {
                this.classToBind1031 = 'favlinkintableactive';
                this.dtElement.dtInstance.then((x) => x.draw(false));
                this._toastService.addToast({
                  title: 'Message',
                  msg: 'You successfully added this property to 1031 exchange!',
                  timeout: 5000,
                  theme: 'bootstrap',
                  position: 'bottom-right',
                  type: 'success',
                });
              } else {
                this.classToBind1031 = 'favlinkintable';
                this.dtElement.dtInstance.then((x) => x.draw(false));
              }

              document.getElementById('closeModal').click();
            });
        } else {
          this._toastService.addToast({
            title: 'Unauthorized Action',
            msg: 'Please select at least one group.',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'error',
          });
        }
      } else {
        this._toastService.addToast({
          title: 'Unauthorized Action',
          msg: 'Please select at least one exchange.',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error',
        });
      }
    } else {
      this._toastService.addToast({
        title: 'Warning',
        msg: 'You have no active 1031 Exchanges currently.',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    }
  }

  // Only for Broker
  open1031ExchangeModal(template: TemplateRef<any>, classes: any, item: any) {
    this.authService.isLoggedIn.subscribe((i) => {
      this.isUserLoggedIn = i;
    });
    this.user = this.authService.user;
    if (this.isUserLoggedIn) {
      if (this.authService.IsUserRole(this.authService.UserRole.Broker)) {
        this.authService.isLoggedIn.subscribe((response) => {
          if (response) {
            let loggedUserDetails = JSON.parse(
              localStorage.getItem('currentUser')
            );
            this.trade1031Service
              .GetExchangeCode(loggedUserDetails.Id)
              .subscribe((res) => {
                this.exchangeCodes = res;
                //this.exchangeCodes.forEach(item => {
                //    let ProjectedSaleDate = this._ValidationService.convertUTCDateToLocalDate(item.ProjectedSaleDate);
                //    item.ExchangeCode = item.ExchangeCode + " " + this._ValidationService.formatDatetoMMDDYYYY(ProjectedSaleDate);
                //    let SaleDateEnd = this._ValidationService.convertUTCDateToLocalDate(this._ValidationService.addDays(ProjectedSaleDate, 180));
                //    item.ExchangeCode = item.ExchangeCode + "-" + this._ValidationService.formatDatetoMMDDYYYY(SaleDateEnd);
                //});
              });
          }
        });

        this._commonService.getLookupsByTypeId(25).subscribe((response) => {
          this.groupList = response.map((o) => {
            return {
              id: o.Id,
              description: o.Description,
            };
          });
        });
        this.addTo1031Exchange.UserId = this.user.Id;
        this.addTo1031Exchange.PropertyId = item.Id;
        this.addTo1031Exchange.Exchange1031Id = item.Exchange1031Id;
        this.addTo1031Exchange.Exchange1031GroupId = 2200; // Suggested
        this.modalRef = this.modalService.show(template, { class: classes });
      } else {
        this._toastService.addToast({
          title: 'Unauthorized Action',
          msg: 'Please Login as a Broker to add your Exchange.',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error',
        });
        this.dtElement.dtInstance.then((x) => x.draw(false));
      }
    } else {
      this._toastService.addToast({
        title: 'Unauthorized Action',
        msg: 'Please Login as a Broker to add your Exchange.',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
      this.dtElement.dtInstance.then((x) => x.draw(false));
    }
  }
  @Output() propertyPriorityChanged: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() decrementPropertyCount: EventEmitter<any> = new EventEmitter<any>();

  addToDisliked(propertyId: any) {
    let property = this.propertiesEx.find((x) => x.Id == propertyId);
    property.IsDisliked = 1;
    this.authService.isLoggedIn.subscribe((i) => {
      this.isUserLoggedIn = i;
    });
    this.user = this.authService.user;
    if (this.isUserLoggedIn) {
      if (
        this.authService.IsUserRole(this.authService.UserRole.Principal) ||
        this.authService.IsUserRole(this.authService.UserRole.Principal1031)
      ) {
        this.addToFavorites.UserId = this.user.Id;
        this.addToFavorites.PropertyId = propertyId;
        this._propertyManagerService
          .addToDisliked(this.addToFavorites)
          .subscribe((response) => {
            if (response == '1') {
              property.IsDisliked = 1;
              this._toastService.addToast({
                title: 'Message',
                msg: 'This property has been removed from your frontend listing page.',
                timeout: 5000,
                theme: 'bootstrap',
                position: 'bottom-right',
                type: 'success',
              });
              this.classToBind = 'favlinkintableactive';
              this.dtElement.dtInstance.then((x) => x.draw(false));
            } else {
              property.IsDisliked = 0;
              this.classToBind = 'favlinkintable';
              this.dtElement.dtInstance.then((x) => x.draw(false));
            }
            this.decrementPropertyCount.emit(1);
          });
      } else {
        property.IsDisliked = 0;
        this._toastService.addToast({
          title: 'Unauthorized Action',
          msg: 'Please Login as a principal to mark as disliked.',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error',
        });
      }
    } else {
      property.IsDisliked = 0;
      this._toastService.addToast({
        title: 'Unauthorized Action',
        msg: 'Please Login to mark as disliked.',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    }
  }
  openMessageTab(template: TemplateRef<any>, classes, Property) {
    var openModelStatus = true;
    Property.UnReadMessageCount = 0;
    if (openModelStatus) {
      if (Property.Guid != '') {
        if (
          this.authService.Admin() ||
          this.authService.SuperAdmin() ||
          (this.authService.Seller() && Property.IsLoggedInSellerProperty)
        ) {
          this._commonService
            .GetPropertyContactPersonList(Property.Id)
            .subscribe((response) => {
              var broker = response.filter((i) => i.Role == 'B+E Broker');
              if (broker.length > 0) {
                this.selectedPropertyGuid = Property.Guid;
                this.propertyChatModel.ExchangeId = 0;
                this.propertyChatModel.PropertyGuid = this.selectedPropertyGuid;
                this.Shared.clickMessage(this.propertyChatModel);
              } else {
                this._toastService.addToast({
                  title: 'No Groups found',
                  msg: 'You cant send messages. No conversation group identified for this property.',
                  timeout: 5000,
                  theme: 'bootstrap',
                  position: 'bottom-right',
                  type: 'error',
                });
              }
            });
        } else {
          this.selectedPropertyGuid = Property.Guid;
          this.propertyChatModel.ExchangeId = 0;
          this.propertyChatModel.PropertyGuid = this.selectedPropertyGuid;
          this.Shared.clickMessage(this.propertyChatModel);
        }
      }
    }
  }
  addDataColumn() {
    if (this.isPropertyForSale) {
      this.Datacolumns = [
        { data: 'Guid' },
        { data: 'Guid' },
        { data: 'Guid' },
        { data: 'PropertySequenceId' },
        { data: 'PropertyName' },
        { data: 'PropertyName' },
        { data: 'PropertyName' },
        { data: 'State' },
        { data: 'City' },
        { data: 'AssetType' },
        { data: 'PropertyStatus' },
        { data: 'Price' },
        { data: 'RentNOI' },
        { data: 'CreditRating' },
        { data: 'CapRate' },
        { data: 'RemainingTerm' },
        { data: 'DateOnMarket' },
        { data: 'LeaseStructure' },
        { data: 'BuildingSize' },

        { data: 'Rank' },
      ];
    } else {
      this.Datacolumns = [
        { data: 'Guid' },
        { data: 'Guid' },
        { data: 'Guid' },
        { data: 'PropertySequenceId' },
        { data: 'PropertyName' },
        { data: 'OMFilePath' },
        { data: 'PropertyName' },
        { data: 'State' },
        { data: 'City' },
        { data: 'AssetType' },
        { data: 'PropertyStatus' },
        { data: 'Price' },
        { data: 'RentNOI' },
        { data: 'CreditRating' },
        { data: 'CapRate' },
        { data: 'RemainingTerm' },
        { data: 'DateOnMarket' },
        { data: 'LeaseStructure' },
        { data: 'BuildingSize' },

        { data: 'Rank' },
      ];
    }
  }

  onSelectAll(event) {
    if (event.target.checked) {
      this.selectOrUnSelectAll(true);
    } else {
      this.selectOrUnSelectAll(false);
    }
  }
  selectOrUnSelectAll(trueOrfalse) {
    this.propertiesEx.forEach((item) => {
      item.IsSelected = trueOrfalse;
      if (trueOrfalse) {
        // if true then push all selected items into selectedRows collection
        if (this.selectedRows.findIndex((x) => x.Id == item.Id) < 0) {
          this.selectedRows.push(item);
        }
      } else {
        // if false then current item from the selected row collection
        this.selectedRows.splice(
          this.selectedRows.findIndex((x) => x.Id == item.Id),
          1
        );
      }
    });
    this.preserveSelectedRows();
    if (!trueOrfalse) {
      this.selectAll = false;
    }
  }

  selectAll = false;
  onCheckboxChange(event, Id) {
    if (event.target.checked) {
      let prop = this.propertiesEx.find((x) => x.Id == Id);
      this.selectedRows.push(prop);
    } else {
      this.selectedRows.splice(
        this.selectedRows.findIndex((x) => x.Id == Id),
        1
      );
    }
    this.preserveSelectedRows();
    this.autoSelectAll();
  }

  modalRefShareListing: BsModalRef;
  modalRefSuggestProperties: BsModalRef;
  selectedProperties: IPropertyCard[];
  modalRefOM: BsModalRef;
  openModalForShareListing(template: TemplateRef<any>, classes: any) {
    this.selectedProperties = this.propertiesEx.filter(
      (x) => x.IsSelected == true
    );
    if (this.selectedProperties.length == 0) {
      this._toastService.addToast({
        title: 'Error Occurred',
        msg: 'Please select at least 1 property.',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    } else {
      this.modalRefShareListing = this.modalService.show(template, {
        class: classes,
      });
    }
  }

  openModalForShareOM(template: TemplateRef<any>, classes: any) {
    this.sharedOmProperties = this.propertiesEx
      .filter((x) => x.IsSelected == true)
      .map((x) => x.Id);
    if (this.sharedOmProperties.length == 0) {
      this._toastService.addToast({
        title: 'Error Occurred',
        msg: 'Please select at least 1 property.',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    } else {
      let sharedOMlength = this.sharedOmProperties.length;
      let fileExist = this.propertiesEx.filter(
        (x) => x.IsSelected == true && x.IsOMExists == 0
      );
      let fileLength = fileExist != null ? fileExist.length : 0;
      if (fileLength == sharedOMlength) {
        this._toastService.addToast({
          title: 'Error Occurred',
          msg: 'OM files not available for the selected properties.',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error',
        });
      } else {
        this.modalRefOM = this.modalService.show(template, { class: classes });
      }
    }
  }

  openModalForSuggestProperty(template: TemplateRef<any>, classes: any) {
    this.selectedProperties = this.propertiesEx.filter(
      (x) => x.IsSelected == true
    );
    if (this.selectedProperties.length == 0) {
      this._toastService.addToast({
        title: 'Error Occurred',
        msg: 'Please select at least 1 property.',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    } else {
      this.modalRefSuggestProperties = this.modalService.show(template, {
        class: classes,
      });
    }
  }
  removeProperty(propertyId: number) {
    this.selectAll = false;
    let prop = this.propertiesEx.find((x) => x.Id == propertyId);
    if (prop) {
      prop.IsSelected = false;
    }
    this.selectedRows.splice(
      this.selectedRows.findIndex((x) => x.Id == propertyId),
      1
    );
    if (propertyId == 0) {
      this.resetSelectedRows();
    }
    this.preserveSelectedRows();
  }

  resetSelectedRows() {
    this.selectedRows = [];
    if (this.propertiesEx) {
      this.propertiesEx.forEach((item) => {
        item.IsSelected = false;
      });
    }
    this.selectAll = false;
    this.preserveSelectedRows();
  }

  preserveSelectedRows() {
    localStorage.setItem(
      'buypage_selectedRows',
      JSON.stringify(this.selectedRows)
    );
    localStorage.setItem(
      'buypage_selectedRows_currentTab',
      JSON.stringify(this._propertyListingService.criteria.PropertyFor)
    );
  }
  reassignSelectedRows() {
    if (
      this.selectedRows.length == 0 &&
      localStorage.getItem('buypage_selectedRows') !== null
    ) {
      if (localStorage.getItem('buypage_selectedRows_currentTab') !== null) {
        if (
          this._propertyListingService.criteria.PropertyFor !==
          parseInt(localStorage.getItem('buypage_selectedRows_currentTab'))
        ) {
          this.resetSelectedRows();
        } else {
          this.selectedRows = JSON.parse(
            localStorage.getItem('buypage_selectedRows')
          );
        }
      } else {
        this.selectedRows = JSON.parse(
          localStorage.getItem('buypage_selectedRows')
        );
      }
    }
  }

  hideColumn(col: number) {
    if (this.selectedColumns.indexOf(col) > -1) {
      return false; // show
    } else {
      return true; // hide
    }
  }

  BindColumns() {
    //this.allowOnchange = false;

    this.tableColumns = [
      { id: 1, name: 'State' },
      { id: 2, name: 'City' },
      { id: 3, name: 'Property Type' },
      { id: 4, name: 'Status' },
      { id: 5, name: 'Asking Price' },
      { id: 6, name: 'Rent NOI' },
      { id: 7, name: 'Credit Rating' },
      { id: 8, name: 'Cap Rate' },
      { id: 9, name: 'Remaining Term' },
      { id: 10, name: 'Lease Structure' },
      { id: 11, name: 'Area (SQ FT)' },
      { id: 13, name: 'Property Id' },
    ];

    //if (this.searchCriteria.AddressType == 1) {
    //    this.tableColumns.push({ id: 12, name: 'Rank' })
    //}

    this.selectedColumns = [];
    var selectedColumnValues = [];

    if (this._propertyListingService.criteria.PropertyFor == 601) {
      if (localStorage.getItem('buypage_sale_selectedColumns_LS') !== null) {
        this.selectedColumns = JSON.parse(
          localStorage.getItem('buypage_sale_selectedColumns_LS')
        );
      } else {
        this.tableColumns.forEach((item) => {
          this.selectedColumns.push(item.id);
        });
      }
    } else {
      if (localStorage.getItem('buypage_1031_selectedColumns_LS') !== null) {
        this.selectedColumns = JSON.parse(
          localStorage.getItem('buypage_1031_selectedColumns_LS')
        );
      } else {
        this.tableColumns.forEach((item) => {
          this.selectedColumns.push(item.id);
        });
      }
    }

    //if (this.searchCriteria.AddressType != 1 && this.selectedColumns.indexOf(12) > -1) {
    //    this.cdRef.detectChanges();
    //    this.selectedColumns.splice(this.selectedColumns.indexOf(12), 1);
    //}
    //else if (this.searchCriteria.AddressType == 1 && this.selectedColumns.indexOf(12) == -1) {
    //    this.cdRef.detectChanges();
    //    this.selectedColumns.push(12);
    //}
    //this.cdRef.detectChanges();
    this.onRedirection();
  }

  onRedirection() {
    if (this._propertyListingService.criteria.PropertyFor == 601) {
      localStorage.setItem(
        'buypage_sale_selectedColumns_LS',
        JSON.stringify(this.selectedColumns)
      );
    } else {
      localStorage.setItem(
        'buypage_1031_selectedColumns_LS',
        JSON.stringify(this.selectedColumns)
      );
    }
  }
  allowOnchange = true;
  onChange(event) {
    //this.selectedColumns = [];
    //this.selectedColumns = event;
    //this.cdRef.detectChanges();
    //
    //if (this.allowOnchange) {
    //    this.onRedirection();
    //}
  }

  getDataTablestate(localStorageName) {
    var data = JSON.parse(localStorage.getItem(localStorageName));
    if (data != null) {
      if (this.searchCriteria.AddressType == 1) {
        var tableStates = JSON.parse(localStorage.getItem('TableStates'));
        if (tableStates != null) {
          tableStates.forEach((item) => {
            if (item.TableName == localStorageName && item.IsSortOrderChanged) {
              item.IsSortOrderChanged = false;
              //data.order = [[this.Datacolumns.findIndex(x => x.data == "Rank"), "desc"]];
              data.order = [
                [this.Datacolumns.findIndex((x) => x.data == 'Price'), 'desc'],
              ];
            }
          });
          localStorage.setItem('TableStates', JSON.stringify(tableStates));
        }
      } else if (
        data.order[0][0] == this.Datacolumns.findIndex((x) => x.data == 'Rank')
      ) {
        data.order = [
          [this.Datacolumns.findIndex((x) => x.data == 'Price'), 'desc'],
        ];
      }

      if (this.propertyForChanged) {
        data.start = 0;
      }
    }
    $('.dataTables_paginate.paging_full_numbers').show();
    return data;
  }

  showPortfolioProperties(id, index) {
    this.searchCriteria.PropertyId = id;
    if (
      this.propertiesEx[index].PortfolioProperties == undefined ||
      this.propertiesEx[index].PortfolioProperties.length == 0
    ) {
      this.loaderService.display(true);
      this._propertyListingService
        .GetPortfolioPropertiesList(this.searchCriteria)
        .subscribe((item) => {
          this.propertiesEx[index].PortfolioProperties = item;
          console.log(item);
          this.propertiesEx[index].PortfolioProperties.forEach((item) => {
            item.Remaining_Term =
              this._ValidationService.remainingTermForCardandTables(
                item.LeaseExpiration,
                item.LeaseCommencementDate
              );
          });
          this.propertiesEx[index].ShowPortfolioProperties = true;
          this.loaderService.display(false);
        });
    } else {
      this.propertiesEx[index].ShowPortfolioProperties =
        !this.propertiesEx[index].ShowPortfolioProperties;
    }
  }

  showAllPortfolioProperties(ids) {
    this.searchCriteria.PropertyIds = ids;
    this.searchCriteria.LoggedInUserId = this.user == null ? 0 : this.user.Id;
    this._propertyListingService
      .GetPortfolioPropertiesListByIds(this.searchCriteria)
      .subscribe((item) => {
        this.searchCriteria.PropertyIds.forEach((k) => {
          let date = item;
          let index = this.propertiesEx.findIndex((x) => x.Id == k);
          this.propertiesEx[index].PortfolioProperties = item.filter(
            (x) => x.PortfolioPropertyId == k
          );
          this.propertiesEx[index].PortfolioProperties.forEach((item) => {
            item.Remaining_Term =
              this._ValidationService.remainingTermForCardandTables(
                item.LeaseExpiration,
                item.LeaseCommencementDate
              );
          });
          this.propertiesEx[index].ShowPortfolioProperties = false;
        });
      });
  }
}
